module.exports = __webpack_public_path__ + "static/media/NunitoSans-Regular.fb98ed17.ttf";